import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { useAdsListQuery } from '../../../../hooks/useAdsQuery';
import Segment from '../../../navigation/Segment/Segment';
import { SegmentItem } from '../../../../types/interfaces/navigation';
import { BackComponent } from '../../../../hooks/useSafeNavigation';
import { Stack, Button, Text } from '@primer/react';
import { ChevronLeftIcon } from '@primer/octicons-react';

interface UserViewSegmentProps {
    id: string
}

const UserViewSegment: React.FC<UserViewSegmentProps> = ({ id }) => {

    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const {
        isLoading: isLoadingAds,
        data: adsData,
        refetch: refetchAds
    } = useAdsListQuery(
        undefined,  // search
        0,              // page
        1,             // limit
        undefined,           // isActive
        "created_at",   // sort
        "desc",         // ordering
        undefined,       // status
        undefined,   // createdFrom
        undefined,   // createdTo
        undefined,            // priceFrom
        undefined,            // priceTo,
        id // userID
    );

    const userTabsData: SegmentItem[] = [
        {
            text: "Пользователь",
            href: "/users/user?id=" + id,
            isDisabled: false
        },
        {
            text: adsData ? `Объявления (${adsData.totalCount})` : "Объявления",
            href: "/users/user/advertisements?id=" + id,
            isDisabled: false
        }
    ];


    useEffect(() => {
        if (adsData === undefined) {
            refetchAds()
        }
    }, []);

    useEffect(() => {
    }, [adsData]);

    return (
        <Stack justify="space-between" direction="horizontal">
            <Stack direction="horizontal">
                <BackComponent fallbackPath="/users" isOnlyFallback={false} />
                <Segment items={userTabsData} />
            </Stack>
        </Stack>
    )
}

export default UserViewSegment